import { ReactNode, useReducer } from 'react';
import Portal from '../../components/Portal';
import Toast from '../../components/Toast';
import ToastContext from './toastContext';
import toastReducer from './toastReducer';
import { ToastStateType } from './toastType';

type ToastStateProps = {
    children: ReactNode;
};

const initialState: ToastStateType = {
    toast: [],
};

const ToastState: React.FC<ToastStateProps> = ({ children }) => {
    const [state, dispatch] = useReducer(toastReducer, initialState);

    return (
        <ToastContext.Provider value={{ ...state, dispatch }}>
            {children}
            <Portal>
                <div className='toast-container'>
                    {state.toast.map((toast) => (
                        <Toast key={toast.id} toast={toast} />
                    ))}
                </div>
            </Portal>
        </ToastContext.Provider>
    );
};

export default ToastState;
